/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 27/10/21
 */

import { ReactComponent as AlertIcon } from './alert-triangle.svg';
import { ReactComponent as AddIcon } from './add.svg';
import { ReactComponent as DeleteIcon } from './delete.svg';
import { ReactComponent as CopyIcon } from './copy.svg';
import { ReactComponent as EditIcon } from './edit.svg';

export default {
    AlertIcon,
    DeleteIcon,
    AddIcon,
    CopyIcon,
    EditIcon,
};
